<template>
  <AssetsDeleted v-bind="{ columns, items, modal, plural: 'assets' }" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { orderBy } from 'lodash'

import { FilterComparison, ModalClass } from '@types'

import { ASSET_FIELD, ASSET_FIELD_LABEL } from '@/entities/assets/utils/const'

import useFiltersService from '@/services/filters'

import { useAssetsDeletedStore } from '@/store/assets/deleted'
import { useAssetsStore } from '@/store/assets/index'
import { useRepositoriesStore } from '@/store/repositories/index'

import AssetsDeleted from '@/modules/modals/AssetsDeleted.vue'

type Props = {
  modal: ModalClass<any>
}
defineProps<Props>()

const assetsStore = useAssetsStore()
const assetsDeletedStore = useAssetsDeletedStore()
const repositoriesStore = useRepositoriesStore()

const { fetchOptions } = useFiltersService()

const assetsTypes = computed(() =>
  orderBy(assetsStore.getTypes, 'value').map(value => ({
    value,
    label: value,
  })),
)
const currenciesList = computed(() =>
  orderBy(repositoriesStore.getCurrencies, 'ticker').map(item => ({
    value: item.ticker,
    label: item.ticker,
  })),
)

const columns = computed(() => [
  {
    name: ASSET_FIELD.TYPE,
    caption: ASSET_FIELD_LABEL[ASSET_FIELD.TYPE],
    filter: {
      isSimple: true,
      defaultComparison: FilterComparison.EQ,
      list: assetsTypes.value,
    },
  },
  {
    name: ASSET_FIELD.NAME,
    caption: ASSET_FIELD_LABEL[ASSET_FIELD.NAME],
    filter: {
      getter: () => fetchOptions('Assets', ASSET_FIELD.NAME),
    },
  },
  {
    name: ASSET_FIELD.TICKER,
    caption: ASSET_FIELD_LABEL[ASSET_FIELD.TICKER],
    filter: {
      getter: () => fetchOptions('Assets', ASSET_FIELD.TICKER),
    },
  },
  {
    name: ASSET_FIELD.CURRENCY,
    caption: ASSET_FIELD_LABEL[ASSET_FIELD.CURRENCY],
    filter: {
      isSimple: true,
      defaultComparison: FilterComparison.EQ,
      list: currenciesList.value,
    },
  },
  {
    name: ASSET_FIELD.DESCRIPTION,
    caption: ASSET_FIELD_LABEL[ASSET_FIELD.DESCRIPTION],
  },
])

const items = computed(() => assetsDeletedStore.getCommonList)
</script>
